import { useEffect, useState } from "react";
import UserContext from "./UserContext";
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { auth } from "../firebase";
import authService from "../services/authService";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";

export const UserState = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loginError, setLoginError] = useState(false);

  useEffect(() => {
    
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setLoading(true);
        const token = await firebaseUser.getIdToken();

        authService
          .getMe()
          .then((res) => {
            setUser({
              uid: firebaseUser.uid,
              email: firebaseUser.email,
              name: firebaseUser.displayName,
              token,
              ...res.data,
            });
          })
          .catch(() => {
            setUser(null);
          }).finally(() => {
            setLoading(false);
          });
      } else {
        setUser(null);
      }

    });

    return () => unsubscribe();
  }, []);

  const registerUser = async ({ name, email, password, phone }) => {
    try {
      setLoginError(false);

      const cred = await createUserWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );

      await updateProfile(cred.user, {
        displayName: name,
      });

      authService.createUser({ name, phone }).catch((error) => {
        alert("Error al registrar en Firestore:", error);
      });

      return true;
    } catch {
      setLoginError(true);
      return false;
    }
  };

  const Login = async (email, password) => {
    setLoginError(false);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch {
      setLoginError(true);
    }
  };

  const googleProvider = new GoogleAuthProvider();

  const LoginWithGoogle = async () => {
    setLoginError(false);
    try {
      await signInWithPopup(auth, googleProvider);
      // onAuthStateChanged se dispara solo, no necesitas hacer nada más aquí
    } catch {
      setLoginError(true);
    }
  };

  const Logout = async () => {
    await signOut(auth);
    setUser(null);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        setLoading,
        loginError,
        registerUser,
        Login,
        Logout,
        LoginWithGoogle
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
